import React, { PureComponent } from "react";

import Template from "./NoAccess.jsx";

export default class AlertController extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      active: props.active !== undefined ? props.active : true,
    };
  }

  show(message) {
    this.setState({ text: message, active: true });
  }

  hide() {
    this.setState({ active: false });
  }

  render() {
    return <Template {...this.props} {...this.state} {...this.handlers} />;
  }
}

export function Provider(C) {
  let alert = {};

  return function Provided(props) {
    return (
      <>
        <C {...props} alert={alert} />
        <AlertController
          ref={(r) => {
            alert.show = (message) => r.show(message);
            alert.hide = () => r.hide();
          }}
          active={false}
        />
      </>
    );
  };
}
